module.exports = __webpack_public_path__ + "static/media/feature-coffee.9bddf87d.jpg";